import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const d = err?.response?.data?.detail;
    if (err?.response?.status === 403 && d && typeof d === "object" && d.code === "portal_paused") {
      if (window.location.pathname !== "/paused") window.location.assign("/paused");
    }
    return Promise.reject(err);
  }
);
